import 'ui-core/widgets/device-pairing/js/device-pairing';
UX.devicePairing.additionalControl = function () {
    let devices = document.querySelectorAll('.device-pairing__row input[type="checkbox"]');
    if (devices !== null || devices.length > 0) {
        [...devices].forEach(function (device) {
            device.onclick = event => {
                let deviceTd = event.currentTarget.closest('tr');
                if (deviceTd !== null) {
                    deviceTd.classList.toggle('device-pairing__row--bold');
                }
            }; // need to recode it using addEventListener
        });
    }
};
